import React, { useEffect, useReducer, useState } from "react";
import {
  GetYojnaDepositDashboardDataByMemberId,
  getConfigValues,
  InsertUpdateYojna,
  CommonDropdownData,
  documentDetails,
  GetUserDetailsByRequestId,
} from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import TrackFalseSlider from "../../Components/Slider/Slider";
import ButtonComponent from "../../Components/ButtonForm/Button";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import CustomModal from "../../Components/Modal/CustomModal";
import InputForm, {
  AutoCompleteValue,
} from "../../Components/InputForm/InputForm";
import { DropdownTypeId } from "../../Helpers/Enums/DropdownTypeId";
import { RiFileListLine } from "react-icons/ri";
import SanjeevaniDepositeModal from "../Common/SanjeevaniDepositeModal/SanjeevaniDepositeModal";
import { SanjeevaniModules } from "../../Helpers/Enums/Modules";
import ImageViewer from "../../Components/ImageViewer/ImageViewer";
import { downloadBlob } from "../../Helpers/Common/BlobHelper";
import "./Sanjeevani.css";
import SanjeevaniForm from "./SanjeevaniForm";
import { AppModules } from "../../Helpers/Enums/AppModules";
import {
  SanjeevaniDepositStatus,
  SanjeevaniWithdrawStatus,
  SuvidhaDepositStatus,
  SuvidhaWithdrawStatus,
} from "../../Helpers/Enums/ApplicationStatus";

const SanjeevaniTransaction = (props) => {
  const { state } = useLocation();
  //   const stateAmount = state ? state.stateAmount : null;
  //  const [amount2, setAmount2] = useState(stateAmount ? stateAmount : 10000);
  const mode = state ? state.mode : null;
  const finalAmtFromList = state ? state.finalAmtFromList : null;
  const context = getContext();
  let { selectNextTab } = props;
  const { appModule } = props;
  const [payable, setPayable] = useState(601);
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [initialdisabled, setInitialDisabled] = React.useState(false);
  const [amount, setAmount] = useState(10000);
  // const [amount, setAmount] = useState(mode === "Edit" ? 10000 : 0);
  // const location = useLocation();
  // const [amount, setAmount] = useState(300000);
  // const YojnaType = location.state?.YojnaType || "SanjivaniYojna";
  // const [monthlyDeclaration, setMonthlyDeclarations] = useState(300);

  const [initialDeposit, setInitialDeposit] = useState(0);
  const [configvalue, setConfigvalue] = useState([]);
  const [bankDetails, setBankDetails] = React.useState([
    { name: "accountname", label: "Account Name", value: "" },
    { name: "accountnumber", label: "Account Number", value: "" },
    { name: "bankname", label: "Bank Name", value: "" },
    { name: "ifsccode", label: "IFSC Code", value: "" },
  ]);
  let MemberId2 = context.MemberId;
  const [sliderMin, setSliderMin] = useState(0);
  const [sliderMax, setSliderMax] = useState(0);
  const [customSliderMarks, setCustomSliderMarks] = useState([]);
  const [submitMsg, setSubmitMsg] = useState("");
  const [sendMemberId, setSendMemberId] = useState(0);
  let formErrorObj = {};
  const [transactionOption, setTransactionOption] = React.useState([]);
  const [TOTNo, setTOTNo] = useState(null);
  const [data, setData] = useState({
    accholdername: "",
    bankName: "",
    AccountNumber: 0,
    BankNameId: 0,
    IFSCCode: 0,
    Name: "",
    terms: false,
    EmailId: "",
    TokenNo: "",
    BankName: "",
    TransactionReferenceNo: null,
    uploadAttachment: null,
  });
  const [modalOpen, setModalOpen] = React.useState(false);
  const [attchName, setAttchName] = useState(null);
  const [binaryDataChq, setBinaryChq] = useState(null);
  const [AttributeError, setAttributeError] = useState("");
  const [TOTErrorDropdown, setTOTErrorDropdown] = useState("");
  const [RTNErrorDropdown, setRTNErrorDropdown] = useState("");
  const [invalidAtt, setInvalidAtt] = useState("");
  const [attachmentSelected, setAttachmentSelected] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  //State from SANReqGrid to check status
  const reqId = state ? state.reqId : null;
  const DocUrl = state ? state.DocUrl : "";
  const TypeOfTransactionId = state ? state.TypeOfTransactionId : "";
  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState<number>(null);
  const [imageEyeIconVisibleNextTab, setImageEyeIconVisibleNextTab] =
    useState(false);
  const [dropDown1, setDropDown1] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [AmountCheck, setAmountCheck] = useState(null);
  const [displaySanjeevaniForm, setDisplaySanjeevaniForm] = useState(false);
  const [FTypeErrors, setFTypeErrors] = useState("");
  const [FSizeErrors, setFSizeErrors] = useState("");
  const [FSizeErrorsConfig, setFSizeErrorsConfig] = useState("");
  const [Extention, setExtention] = useState("");
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const Id = state ? state.Id : null;
  const currentStatus =
    state !== null && state.currentStatus ? state.currentStatus : 0;
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (imageIndex !== null) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  useEffect(() => {
    if (!showImageViewer) {
      setImageIndex(null);
    }
  }, [showImageViewer]);

  useEffect(() => {
    getTransactionData();
    getConfigData();
    // sequenceFunCall();
  }, []);

  useEffect(() => {
    async function fetchData() {
      await getTransactionData();
      await getFormData();
    }
    fetchData();
  }, [MemberId2]);

  useEffect(() => {
    if (dropDown1) {
      databyRequestid();
    }
  }, [transactionOption, bankDetails]);

  // finalAmtFromList

  // in case config data is not get properly then call this in squence
  const sequenceFunCall = async () => {
    showLoader();
    await getConfigData();
    await SubmitForm();
    hideLoader();
  };

  //Data from dashboard for sanjeevani
  const databyRequestid = async () => {
    showLoader();
    if (reqId !== null && transactionOption.length > 0) {
      const param1 = {
        RequestId: reqId,
        YojnaType:
          appModule === AppModules.SuvidhaYojna
            ? "SuvidhaYojna"
            : "SanjivaniYojna",
        CreatedBy: context.Id,
      };
      const GetEditUserRoleResp = await APICall(
        GetUserDetailsByRequestId,
        param1
      );
      if (GetEditUserRoleResp?.Data?.SNJY_MemberDetails.length > 0) {
        const SanjeevaniFormData =
          GetEditUserRoleResp?.Data?.SNJY_MemberDetails[0];
        setData({
          ...data,
          BankName: SanjeevaniFormData.BankName,
          AccountNumber: SanjeevaniFormData.AccountNumber,
          IFSCCode: SanjeevaniFormData.IFSCCode,
          Name: SanjeevaniFormData.Name,
          TransactionReferenceNo: SanjeevaniFormData.TransactionReferenceNo,
        });
        const objTOTNo = transactionOption.find(
          (d) => d.value === TypeOfTransactionId
        );
        setTOTNo(objTOTNo);
        setAmount(SanjeevaniFormData.Amount);

        // if (reqId != 0) {
        setImageEyeIconVisibleNextTab(true);
        // }
        let newImages = [];
        // const img = SanjeevaniFormData.DocUrl ;
        const img = DocUrl;
        // if (img) {
        let imgUrl = await downloadBlob(img);
        let fileType = img?.toLowerCase()?.endsWith(".pdf") ? "pdf" : "image";
        newImages.push({
          src: imgUrl,
          fileType: fileType,
          title: "Attachment",
        });
        // console.log("img", img);
        setImages(newImages);
        // }
      }
      setDropDown1(false);
      hideLoader();
    }
    hideLoader();
  };

  //Dropdown Data type of transaction
  const getTransactionData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.SanjeevaniTransactionType,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message === "Success" && result.Data.length > 0) {
      setTransactionOption(result.Data);
    }
  };
  // console.log("current appModule in sanjeevani transaction " + appModule);

  const getConfigData = async () => {
    let temp = [];
    let minLimitKey = "";
    let maxLimitKey = "";
    let submitKey = "";
    let customSliderMarks = [];
    let fileSizeLimitKey = "";
    let fileExtentionKey = "";

    if (appModule === AppModules.SanjeevaniYojana) {
      temp = [
        ...bankDetails.map((bd) => bd.name),
        "SNJYDepositMinLImit",
        "SNJYDepositMaxLImit",
        "SNJYSubmit",
        "filesizeErrorSAN",
        "fileExtentionSAN",
      ];
      minLimitKey = "SNJYDepositMinLImit";
      maxLimitKey = "SNJYDepositMaxLImit";
      submitKey = "SNJYSubmit";
      fileSizeLimitKey = "filesizeErrorSAN";
      fileExtentionKey = "fileExtentionSAN";
    } else if (appModule === AppModules.SuvidhaYojna) {
      temp = [
        ...bankDetails.map((bd) => bd.name),
        "SUVYDepositMinLImit",
        "SUVYDepositMaxLImit",
        "SNJYSubmit",
        "filesizeErrorSUV",
        "fileExtentionSUV",
      ];
      minLimitKey = "SUVYDepositMinLImit";
      maxLimitKey = "SUVYDepositMaxLImit";
      submitKey = "SNJYSubmit";
      fileSizeLimitKey = "filesizeErrorSUV";
      fileExtentionKey = "fileExtentionSUV";
    }

    let arr = [];
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: temp });
    arr = getdata.Data ? getdata.Data?.map((c) => c?.Value) : [];
    setConfigvalue(arr);

    if (getdata.Status === ApiStatus.OK && getdata?.Data?.length > 0) {
      const confData = getdata?.Data;
      const updatedBankDetails = bankDetails.map((detail) => {
        const configItem = confData.find(
          (config) => config.Key === detail.name
        );
        return {
          ...detail,
          value: configItem ? configItem.Value : detail.value,
        };
      });
      setBankDetails(updatedBankDetails);

      const minLimit =
        confData.find((config) => config.Key === minLimitKey)?.Value || 0;
      const numMin = Number(minLimit);
      const maxLimit =
        confData.find((config) => config.Key === maxLimitKey)?.Value || 0;
      const numMax = Number(maxLimit);

      setSliderMin(numMin);
      setSliderMax(numMax);

      if (appModule === AppModules.SanjeevaniYojana) {
        customSliderMarks = [
          { value: numMin, label: `Min ${numMin}` },
          { value: 20000, label: `` },
          { value: 30000, label: `` },
          { value: 40000, label: `` },
          { value: 50000, label: `` },
          { value: 60000, label: `` },
          { value: 70000, label: `` },
          { value: 80000, label: `` },
          { value: 90000, label: `` },
          { value: 100000, label: `` },
          { value: 150000, label: `` },
          { value: 200000, label: `` },
          { value: 250000, label: `` },
          { value: numMax, label: `Max ${numMax}` },
        ];
      } else if (appModule === AppModules.SuvidhaYojna) {
        customSliderMarks = [
          { value: numMin, label: `Min ${numMin}` },
          { value: 20000, label: `` },
          { value: 30000, label: `` },
          { value: 40000, label: `` },
          { value: numMax, label: `Max ${numMax}` },
        ];
      }

      setCustomSliderMarks(customSliderMarks);

      const submitMsg =
        confData.find((config) => config.Key === submitKey)?.Value || "";
      setSubmitMsg(submitMsg);

      const fileSizeLimit =
        confData.find((config) => config.Key === fileSizeLimitKey)?.Value || "";
      setFSizeErrorsConfig(fileSizeLimit);

      const fileExe =
        confData.find((config) => config.Key === fileExtentionKey)?.Value || "";
      setExtention(fileExe);
      forceUpdate();
    }
  };

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  //Change slider values
  const payAble = (key: any, value: any) => {
    if (key === "initaldeposit") {
      setInitialDeposit(value.target.value + 1);
      setPayable(amount + value.target.value + 1);
      onChange("amount", amount + value.target.value + 1);
    }
    if (key === "monthlydeductions") {
      setAmount(value.target.value);
      setPayable(initialDeposit + value.target.value);
      onChange("amount", amount + value.target.value + 1);
    }
    //setPayable(initialDeposit + amount)
  };
  // const MAX_LENGTH = 15;
  // handleTRNChange
  const handleTRNChange = (event) => {
    let input = event.target.value;
    setRTNErrorDropdown("");
    // if (input.length > MAX_LENGTH) {
    //   setRTNErrorDropdown("Max limit is 15");
    //   input = input.slice(0, MAX_LENGTH);
    // }
    input = input.replace(/[^a-zA-Z0-9]/g, "");
    setData({
      ...data,
      TransactionReferenceNo: input,
    });
  };

  // handleTypeOfTransactionChange
  const handleTypeOfTransactionChange = (val) => {
    setTOTErrorDropdown(""); // Clear the error message
    setTOTNo(val);
  };

  // get all fields data from backend
  const getFormData = async () => {
    showLoader();
    let obj = {
      MemberId: Id ? Id : MemberId2,
      YojnaType:
        appModule === AppModules.SuvidhaYojna
          ? "SuvidhaYojna"
          : "SanjivaniYojna",
    };
    // if (transactionOption.length > 0) {
    const resp = await APICall(GetYojnaDepositDashboardDataByMemberId, obj);
    if (resp?.Data?.SNY_DepositList.length > 0) {
      const SanjeevaniFormData = resp?.Data?.SNY_DepositList[0];
      setData({
        ...data,
        BankName: SanjeevaniFormData.BankName,
        AccountNumber: SanjeevaniFormData.AccountNumber,
        IFSCCode: SanjeevaniFormData.IFSCCode,
        Name: SanjeevaniFormData.Name,
      });
      setAmountCheck(SanjeevaniFormData.Amount);
      setSendMemberId(SanjeevaniFormData.MemberId);
      // }
    }
    hideLoader();
  };

  // Submit all data with validation
  const SubmitForm = async () => {
    showLoader();
    // check here member submit only one time
    if (isSubmitting) {
      return;
    }
    let isValid = true;

    if (!data.TransactionReferenceNo) {
      setRTNErrorDropdown("Please type Transaction Ref No");
      isValid = false;
    }

    if (!attchName) {
      setAttributeError("Please select Attachment");
      isValid = false;
    }

    if (!TOTNo) {
      setTOTErrorDropdown("Please select a Type of Transaction.");
      isValid = false;
    }
    // ()
    if (
      (appModule === AppModules.SanjeevaniYojana && totalAmount > 300000) ||
      (appModule === AppModules.SuvidhaYojna && totalAmount > 50000)
    ) {
      setErrorMessage(
        `Additional FD that can be invested is  ${sliderMax - AmountCheck} .`
      );
      isValid = false;
    }

    if (!binaryDataChq && attachmentSelected) {
      setInvalidAtt("Invalid Attachment");
      isValid = false;
    }

    if (isValid) {
      setIsSubmitting(true);
      try {
        let param2 = {
          DocumentName: attchName,
          DocumentType: attchName.split(".").pop(),
          DocumentUrl: "",
          BinaryFile: data.uploadAttachment,
          CreatedBy: MemberId2,
          //  IsActive: true
        };
        const insertData = await APICall(documentDetails, param2);
        let docId = null;
        showLoader();
        if (insertData.Status === ApiStatus.OK && insertData?.Data) {
          docId = insertData.Data;
          setIsSubmitting(true);
        } else {
          notify(
            ToastType.Error,
            insertData?.Message ||
              "Failed to upload document, Please try again later."
          );
          setIsSubmitting(true);
          // hideLoader();
          return;
        }
        let param = {
          MemberId: MemberId2,
          Amount: amount,
          TransactionReferenceNo: data.TransactionReferenceNo,
          TypeOfTransactionId: TOTNo.value,
          DocId: docId,
          StatusId: 0,
          YojnaType:
            appModule === AppModules.SuvidhaYojna
              ? "SuvidhaYojna"
              : "SanjivaniYojna",
          CreatedBy: context.Id,
        };
        const insertYojna = await APICall(InsertUpdateYojna, param);
        if (insertYojna.Status === ApiStatus.OK) {
          showLoader();
          setModalOpen(true);
          setIsSubmitting(true);
          // selectNextTab();
          // hideLoader();
        }
        if (insertYojna.Status === ApiStatus.Error) {
          notify(1, "Something went wrong");
          setIsSubmitting(true);
          hideLoader();
        }
      } catch (error) {
        console.error("Error:", error);
        setIsSubmitting(true);
        hideLoader();
      } finally {
        setIsSubmitting(true);
        hideLoader();
      }
    }
    hideLoader();
  };

  const handleYesFunctionality = () => {
    hideLoader();
    modalOpen === true ? setModalOpen(false) : setModalOpen(true);
    selectNextTab(3);
  };

  const handleCloseModal = () => {
    // setModalOpen(false);
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  // Base 64
  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  //Upload the Attachment
  const onChangeUpload = async (key, value) => {
    setAttributeError("");
    if (key == "uploadAttachment" && value.target.files.length > 0) {
      setAttachmentSelected(true);
      // let errormessage = "attchError";
      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["jpeg", "png", "jpg", "pdf"];
      let validfile = e.split(".").pop();
      setAttchName(e);
      if (!extension.includes(validfile)) {
        await setFTypeErrors("File should be only jpeg or png or pdf");
        setFSizeErrors("");
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        await setFSizeErrors(`${FSizeErrorsConfig}`);
        setFTypeErrors("");
        value = file.name;
      } else {
        setFTypeErrors("");
        setFSizeErrors("");
        // await setFormErrors({
        //   ...formErrors,
        //   [errormessage]: "",
        // });
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }

        setBinaryChq(fileBase64);
        value = fileBase64;
      }
    }
    await setData({ ...data, [key]: value });
  };

  // Document upload api

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const onSubmitValidation = async () => {};

  //Verify on click button
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    let eventData = event.currentTarget;
    // await onSubmitValidation();

    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (isEmpty) {
      setAnchorEl(eventData);
    }
  };

  const handleSliderChange = (e) => {
    const newTotalAmount = AmountCheck + e.target.value;
    // if (newTotalAmount > 300000) {
    // setErrorMessage("");
    // setErrorMessage(
    //   `Your total amount exceeds 300,000 and your actual amount is ${AmountCheck}.`
    // );
    // } else {
    // setErrorMessage("");
    // }
    setErrorMessage("");
    setTotalAmount(newTotalAmount);
  };

  return (
    <>
      <div className="container-fluid">
        <>
          {displaySanjeevaniForm ? (
            <SanjeevaniForm appModule={appModule} />
          ) : (
            <>
              <CustomModal
                show2={modalOpen}
                handleClose2={handleCloseModal}
                onHide2={() => setModalOpen(false)}
                title="<h5>REQUEST SENT SUCCESSFULLY</h5>"
                body={`<p>${submitMsg}</p><b>Note : FD will be created on 1st day of next month.</b>`}
                hideButton1={false}
                buttonLabel1="Go To Statment"
                handleYesFunctionality={handleYesFunctionality}
                buttonLabel2={""}
                hideButton2={true} //Hide the 1st button
              />

              {/* table for bank details */}
              <div className="detail_bank">
                <ul>
                  {bankDetails.map((bd) => {
                    return (
                      <>
                        <li>
                          <span className="table-bank-details-data">
                            {bd.label}
                          </span>{" "}
                          :
                          <span
                            className="table-bank-details-data"
                            style={{ marginLeft: "5px" }}
                          >
                            {bd.value}
                          </span>
                        </li>
                      </>
                    );
                  })}
                </ul>
              </div>

              {/* Slider */}
              <div className="row d-flex justify-content-center">
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <h4>Amount</h4>
                  </div>
                </div>

                {/* Main slider */}
                {context.loggedInAs.label === "Member" && (
                  <div
                    className="col-lg-6 col-sm-6 col-xs-6 "
                    style={{ marginTop: "20px", padding: "0px 60px" }}
                  >
                    <TrackFalseSlider
                      valuetext={(e) => {
                        payAble("monthlydeductions", e);
                        handleSliderChange(e);
                      }}
                      value={amount}
                      disabled={initialdisabled}
                      min={sliderMin}
                      max={sliderMax}
                      step={null}
                      marks={customSliderMarks}
                    />
                  </div>
                )}
                {/* Display slider selected final  */}
                {!(mode === "Edit" || mode === "View") && (
                  <div
                    className="col-lg-2 col-sm-2 col-xs-2 "
                    style={{ marginTop: "20px" }}
                  >
                    <div className="form-group">
                      <InputForm
                        placeholder={""}
                        value={amount}
                        disabled={initialdisabled}
                      />
                      {errorMessage && (
                        <p className="text-danger">{errorMessage}</p>
                      )}
                    </div>
                  </div>
                )}
                {/* Display slider selected final amount from withdraw */}
                {(mode === "Edit" || mode === "View") && (
                  <div
                    className="col-lg-2 col-sm-2 col-xs-2 "
                    style={{ marginTop: "20px" }}
                  >
                    <div className="form-group">
                      <InputForm
                        placeholder={""}
                        value={finalAmtFromList}
                        disabled={initialdisabled}
                      />
                      {errorMessage && (
                        <p className="text-danger">{errorMessage}</p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="row ">
                {/* Name */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group ">
                    <label>Name</label>
                    <InputForm
                      value={data.Name}
                      placeholder={"Name"}
                      isDisabled={true}
                      textArea={false}
                      onChange={"onSearchFilter"}
                    />
                  </div>
                </div>

                {/* Amount */}
                {/* <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group ">
                        <label>Amount</label>
                        <InputForm
                          placeholder={"Amount"}
                          value={amount}
                          onChange={handleAmountChange}
                          type="text"
                          isDisabled={false}
                        />
                      </div>
                    </div> */}

                {/* Bank Name */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group ">
                    <label>Bank Name</label>
                    <InputForm
                      placeholder={"Bank Name"}
                      value={data.BankName}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("bankName", value);
                      }}
                      isDisabled={true}
                    />
                  </div>
                </div>

                {/* IFSC Code */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group ">
                    <label>IFSC Code</label>
                    <InputForm
                      placeholder={""}
                      value={data.IFSCCode}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("ifsc", value);
                      }}
                      isDisabled={true}
                    />
                  </div>
                </div>

                {/* Account Number */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group ">
                    <label>Account Number</label>
                    <InputForm
                      placeholder={""}
                      maxlength={20}
                      value={data.AccountNumber}
                      type="number"
                      isDisabled={true}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>

                {/* Transaction Ref No */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group ">
                    <label>Transaction Ref No </label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={"Transaction Ref No"}
                      type="text"
                      value={data.TransactionReferenceNo}
                      onChange={handleTRNChange}
                      isDisabled={state?.Id ? true : false}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  {RTNErrorDropdown && (
                    <p className="text-danger">{RTNErrorDropdown}</p>
                  )}
                </div>

                {/* Type Of Transaction */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Type of Transaction</label>
                    <sup>*</sup>
                    <SelectForm
                      value={TOTNo}
                      placeholder=""
                      options={transactionOption}
                      isDisabled={state?.Id ? true : false}
                      // onChange={(val: any) => onChange("typeoftransaction", val)}
                      onChange={(val) => handleTypeOfTransactionChange(val)}
                    />
                    {TOTErrorDropdown && (
                      <p className="text-danger">{TOTErrorDropdown}</p>
                    )}
                  </div>
                </div>

                {/* Attachment */}
                {/* {context.loggedInAs.label == "Member" && ( */}
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group"></div>
                  <label>Attachment</label>
                  <sup>*</sup>

                  <input
                    autoComplete={AutoCompleteValue}
                    name="file-8[]"
                    id="file-8-chque"
                    className="form-control inputfile inputfile-6"
                    onChange={(e) => onChangeUpload("uploadAttachment", e)}
                    type="file"
                    disabled={state?.Id ? true : false}
                  />
                  <label
                    htmlFor="file-8-chque"
                    className="form-control"
                    style={{ border: "none" }}
                  >
                    <span style={{ float: "right" }}>{attchName}</span>
                    <strong
                      style={{
                        width: "30%",
                        left: "0",
                        borderTopRightRadius: "0",
                        borderBottomRightRadius: "0",
                      }}
                    >
                     <i className="far fa-file"></i> Browse
                    </strong>
                  </label>
                  <div>
                    <p style={{ fontSize: "11px" }}>{`${Extention}`}</p>
                  </div>
                  {AttributeError && (
                    <p className="text-danger">{AttributeError}</p>
                  )}
                  {attachmentSelected && invalidAtt && (
                    <p className="text-danger">{invalidAtt}</p>
                  )}
                  {FTypeErrors && <p className="text-danger">{FTypeErrors}</p>}
                  {FSizeErrors && <p className="text-danger">{FSizeErrors}</p>}
                </div>
                {/* )} */}
                {/* Attachment view */}
                {imageEyeIconVisibleNextTab && (
                  <div className="col-lg-1 col-sm-1 col-xs-1 ">
                    <div
                      className="form-control pe-pointer view_btn"
                      style={{
                        border: "none",
                        order: "none",
                        position: "absolute",
                      }}
                      onClick={() => {
                        if (images?.[0]?.fileType === "pdf") {
                          window.open(images?.[0]?.src, "_blank");
                        } else {
                          setImageIndex(0);
                        }
                      }}
                    >
                      <i className="fa fa-eye"></i>
                    </div>
                  </div>
                )}
              </div>

              <ImageViewer
                open={showImageViewer}
                images={images}
                imageIndex={imageIndex}
                onClose={() => setShowImageViewer(false)}
              />

              {/*Back & Submit when member is login */}
              {context.loggedInAs.label === "Member" && (
                <div className="d-flex justify-content-end">
                  <ButtonComponent
                    icon={"far fa-hand-point-left"}
                    value={"Back"}
                    className="btn btn-primary btn-back"
                    onClick={() => {
                      setDisplaySanjeevaniForm(true);
                    }}
                  />
                  <ButtonComponent
                    icon={"fas fa-paper-plane"}
                    style={{ marginLeft: "10px" }}
                    value={"SUBMIT"}
                    onClick={() => {
                      SubmitForm();
                      setIsSubmitting(false);
                    }}
                    disabled={isSubmitting}
                  />
                </div>
              )}

              {context.loggedInAs.label === "Admin" &&
                (currentStatus === SanjeevaniDepositStatus.Deposit_Rejected ||
                  currentStatus === SuvidhaDepositStatus.SU_Deposit_Rejected ||
                  currentStatus === SuvidhaDepositStatus.SU_Deposit_Approved ||
                  currentStatus === SanjeevaniDepositStatus.Deposit_Approved ||
                  currentStatus ===
                    SuvidhaDepositStatus.SU_FD_Number_genrator_pending ||
                  currentStatus ===
                    SanjeevaniWithdrawStatus.FD_Withdraw_Approved ||
                  currentStatus ===
                    SanjeevaniDepositStatus.FD_Number_genrator_pending ||
                  currentStatus ===
                    SanjeevaniWithdrawStatus.FD_Withdraw_Number_genrator_pending ||
                  currentStatus ===
                    SuvidhaWithdrawStatus.SU_FD_Withdraw_Number_genrator_pending) && (
                  <div className="d-flex justify-content-end">
                    <ButtonComponent
                      icon={""}
                      value={"Back"}
                      className="btn btn-primary btn-back"
                      onClick={() => {
                        setDisplaySanjeevaniForm(true);
                      }}
                    />{" "}
                  </div>
                )}

              {/* Verify when Admin is login */}
              {context.loggedInAs.label === "Admin" &&
                (currentStatus ===
                  SanjeevaniDepositStatus.Deposit_Approval_Pending ||
                  currentStatus ===
                    SanjeevaniWithdrawStatus.FD_Withdraw_Approval_pending ||
                  currentStatus ===
                    SuvidhaDepositStatus.SU_Deposit_Approval_pending ||
                  currentStatus ===
                    SuvidhaWithdrawStatus.SU_FD_Withdraw_Approval_pending) && (
                  <div className="d-flex justify-content-end">
                    <ButtonComponent
                      icon={"far fa-hand-point-left"}
                      value={"Back"}
                      className="btn btn-primary btn-back"
                      onClick={() => {
                        setDisplaySanjeevaniForm(true);
                      }}
                    />
                    <ButtonComponent
                      icon={"fas fa-check-double"}
                      value={"Verify"}
                      style={{ marginLeft: "10px" }}
                      id={"saveBtn"}
                      onClick={handleClick}
                      // disabled={}
                    >
                    
                    </ButtonComponent>
                  </div>
                )}

              <SanjeevaniDepositeModal
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                // module={Modules.LoanModuleApproval}
                module={SanjeevaniModules.ModuleApproval}
                appModule={appModule}
                sendMemberId={sendMemberId}
              />
            </>
          )}
        </>
      </div>
    </>
  );
};

export default SanjeevaniTransaction;
